import React from 'react';
import PropTypes from 'prop-types';
import domainModel from 'domain-model';
import Money from './Money';

const fontSizes = {
  lg: 'text-lg',
  normal: '',
  sm: 'text-sm',
  xs: 'text-xs',
};

type PriceSpanProps = {
  pricedArticle: any;
  fontSize: 'lg' | 'sm';
  fontWeight: string;
  showOriginalPrice: boolean;
};

export default function PriceSpan({
  pricedArticle,
  fontSize,
  fontWeight,
  showOriginalPrice,
}: PriceSpanProps) {
  const articleViewModel =
    domainModel.pricedArticle.getViewModel(pricedArticle);

  return (
    <span
      className={`text-nowrap priceSpan fw-${fontWeight} ${
        fontSizes[fontSize]
      } ${
        articleViewModel.shouldHighlightPriceAsDiscounted ? 'text-danger' : ''
      }`}
    >
      <Money
        currency={pricedArticle.currency}
        value={articleViewModel.displayTotalSalesPrice}
      ></Money>{' '}
      {showOriginalPrice &&
        articleViewModel.displayTotalSalesPrice <
          articleViewModel.displayTotalListPrice && (
          <span className="text-muted text-decoration-line-through">
            <Money
              currency={pricedArticle.currency}
              value={articleViewModel.displayTotalListPrice}
            ></Money>
          </span>
        )}
    </span>
  );
}

PriceSpan.propTypes = {
  pricedArticle: PropTypes.object.isRequired,
  fontSize: PropTypes.oneOf(['lg', 'normal', 'sm', 'xs']),
  fontWeight: PropTypes.string,
  showOriginalPrice: PropTypes.bool,
};

PriceSpan.defaultProps = {
  fontSize: 'normal',
  fontWeight: 'bold',
  showOriginalPrice: false,
};
